import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import iconMapMarker from './icon-map-marker.svg';
import iconPhone from './icon-phone.svg';

export const Location = ({location, designated, onDesignate}) => {
    return <div className="ds-location-card">
        <div className="ds-tags">
            {location.tags.map((tag, i) =>
                <div key={tag} className={tag}></div>
            )}
        </div>
        <h4 className="ds-location-name">{location.company || location.name}</h4>
        <p className="ds-location-address">
            {location.street}{location.street2 && ", " + location.street2}, {location.city}, {location.state} {location.zip}
        </p>
        <p>
           {location.phone &&  <a href={"tel:"+location.phone} className="ds-location-phone" target="_blank"><img src={iconPhone} alt="Phone" /> {formatPhone(location.phone)}</a>}
            <a href={mapUrl(location)} className="ds-location-direction" target="_blank"><img src={iconMapMarker} alt="Directions" /> Get Directions</a>
        </p>
        {designated
            ? <a onClick={() => onDesignate(null)} className="ds-button ds-location-select selected">You've selected this location.</a>
            : <a onClick={() => onDesignate(location.id)} className="ds-button ds-location-select">Select this location</a>
        }
    </div>
}

export const LocationsList = ({locations, designatedId, onDesignate}) => {
    useEffect(() => {
        const e = new Event('locator.locations-list-ready')
        window.dispatchEvent(e)
    })
    return <div className="ds-location-list">
        {locations.map((location, i) =>
            <Location
                key={location.id}
                location={location}
                designated={location.id === designatedId}
                onDesignate={onDesignate}
            />
        )}
    </div>
}

export function formatPhone(value) {
    const onlyNums = value.replace(/[^\d]/g, '');

    return '(' + onlyNums.slice(0, 3) + ') ' + onlyNums.slice(3, 6) + '-' + onlyNums.slice(6, 10)
}

const mapUrl = (location) => {
    const address = [
        location.street,
        location.city,
        location.state,
        location.zip,
    ].join(' ');

    return "http://maps.google.com/?q=" + encodeURIComponent(address);
}

Location.propTypes = {
    location: PropTypes.shape({
        id: PropTypes.number.isRequired,
        street: PropTypes.string,
        street2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string,
        phone: PropTypes.string,
        company: PropTypes.string,
    }),
    designated: PropTypes.bool,
    onDesignate: PropTypes.func,
}
